import BusinessVerticalsService from "@/api/services/businessVerticals";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.records;
      state.currentPage = data.page.currentPage || 1;
      state.totalPages = data.page.totalPages || 0;
      state.totalCount = data.page.totalCount || 0;
    },
  },
  actions: {
    async fetchIndex({ commit }, { storeId, enabled, page } = {}) {
      const response = await BusinessVerticalsService.fetchIndex({ page, storeId, enabled });

      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data);
      return data;
    },
    async fetch(_, { storeId, enabled, includes } = {}) {
      const response = await BusinessVerticalsService.fetch(storeId, enabled, includes);
      if (!response?.success) return response;
      return { ...response, data: toCamelCase(response.data) };
    },
    async new(_, { storeId } = {}) {
      const response = await BusinessVerticalsService.fetchNewOptions(storeId);
      if (!response?.success) return response;
      return { ...response, data: toCamelCase(response.data) };
    },
    async create(_, { storeId, data } = {}) {
      const response = await BusinessVerticalsService.create(storeId, data);
      if (!response?.success) return response;
      return { ...response, data: toCamelCase(response.data) };
    },
    async update(_, { businessVerticalId, data } = {}) {
      const response = await BusinessVerticalsService.update(businessVerticalId, data);
      if (!response?.success) return response;
      return { ...response, data: toCamelCase(response.data) };
    },
  },
};
